var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 109,
    viewBox: "0 0 118 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17781",
    "data-name": "Rectangle 17781",
    width: 117.446,
    height: 107.704,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35291",
    "data-name": "Group 35291",
    transform: "translate(-1055.502 -584.156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17794",
    "data-name": "Rectangle 17794",
    width: 118,
    height: 109,
    transform: "translate(1055.502 584.156)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35259",
    "data-name": "Group 35259",
    transform: "translate(1055.884 584.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35258",
    "data-name": "Group 35258",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44226",
    "data-name": "Path 44226",
    d: "M219.409,75.765A52.035,52.035,0,1,1,167.374,23.73a52.035,52.035,0,0,1,52.035,52.035",
    transform: "translate(-106.598 -21.932)",
    fill: "#f4f7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44227",
    "data-name": "Path 44227",
    d: "M447.62,459.135V511.61a4.536,4.536,0,0,1-4.553,4.553,4.465,4.465,0,0,1-4.378-4.465v-1.372h-.021V464.973a4.465,4.465,0,0,0-4.465-4.465H403.77l-30,.4V447.27a4.465,4.465,0,0,1,4.472-4.464l22.883.031a3.088,3.088,0,0,1,2.337,1.074L411.8,453.6a3.088,3.088,0,0,0,2.341,1.074h29.016a4.465,4.465,0,0,1,4.465,4.465",
    transform: "translate(-345.443 -409.249)",
    fill: "#f2a66e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44228",
    "data-name": "Path 44228",
    d: "M530.865,74.3l-13.088,44,35.839,10.661,13.088-44Zm32.919,16.111-3.5-6.466,4.984,1.482Z",
    transform: "translate(-478.538 -68.669)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44229",
    "data-name": "Path 44229",
    d: "M976.143,325.442l-1.193-.355,11.361-38.195.749,1.844Z",
    transform: "translate(-901.065 -265.151)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44230",
    "data-name": "Path 44230",
    d: "M1083.651,203.052l-1.483,4.984-3.5-6.466Z",
    transform: "translate(-996.922 -186.294)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44231",
    "data-name": "Path 44231",
    d: "M549.239,96.1,537.878,134.3l-35.839-10.661,12.844-43.178,30.855,9.178Z",
    transform: "translate(-463.992 -74.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44232",
    "data-name": "Path 44232",
    d: "M1064.089,208.035l-4.984-1.482,1.482-4.984Z",
    transform: "translate(-978.843 -186.293)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44233",
    "data-name": "Path 44233",
    d: "M755.253,299.826a1.136,1.136,0,0,1-.7-1.582,6.6,6.6,0,0,1,.809-1.294,4.627,4.627,0,0,1,2.619-1.469q.537-.138,1.309-.288a9.513,9.513,0,0,0,1.555-.447,4.994,4.994,0,0,0,1.417-.818,2.741,2.741,0,0,0,.888-1.372,2.591,2.591,0,0,0,.091-1.2,2.686,2.686,0,0,0-.394-1.01,2.767,2.767,0,0,0-.777-.777,3.745,3.745,0,0,0-1.029-.488,3.265,3.265,0,0,0-1.283-.134,4.33,4.33,0,0,0-1.159.283,5.066,5.066,0,0,0-1.025.555,1.144,1.144,0,0,1-1.548-.219l-.767-.952a1.13,1.13,0,0,1,.134-1.562,5.978,5.978,0,0,1,.785-.575,6.692,6.692,0,0,1,1.854-.787,7.271,7.271,0,0,1,2.033-.222,8.124,8.124,0,0,1,2.081.338,8.31,8.31,0,0,1,2.179,1.012,6.036,6.036,0,0,1,1.7,1.664,5.75,5.75,0,0,1,.9,2.3,6.353,6.353,0,0,1-.247,2.886,6.123,6.123,0,0,1-.738,1.648,4.98,4.98,0,0,1-1.055,1.157,5.941,5.941,0,0,1-1.328.8,11.935,11.935,0,0,1-1.586.553q-.716.184-1.423.337a7.611,7.611,0,0,0-1.33.414,3.772,3.772,0,0,0-1.1.7,2.183,2.183,0,0,0-.361.43,1.141,1.141,0,0,1-1.283.486Zm-2.889,5.662.6-2.02a1.133,1.133,0,0,1,1.409-.763l1.2.357a1.133,1.133,0,0,1,.763,1.409l-.6,2.02a1.133,1.133,0,0,1-1.409.763l-1.2-.357a1.133,1.133,0,0,1-.763-1.409",
    transform: "translate(-695.303 -263.835)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44234",
    "data-name": "Path 44234",
    d: "M134.517,238.193l2.5,28.025,22.827-2.035-2.5-28.025Zm22.4,1.73-3.457-2.891,3.174-.283Z",
    transform: "translate(-124.323 -218.261)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44235",
    "data-name": "Path 44235",
    d: "M432.988,310.1l-.76.068-2.169-24.328.844.881Z",
    transform: "translate(-397.468 -264.181)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44236",
    "data-name": "Path 44236",
    d: "M387.612,243.956l.283,3.174-3.457-2.891Z",
    transform: "translate(-355.303 -225.469)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44237",
    "data-name": "Path 44237",
    d: "M148.219,250.582l2.169,24.328-22.827,2.035-2.452-27.5,19.653-1.752Z",
    transform: "translate(-115.628 -228.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44238",
    "data-name": "Path 44238",
    d: "M387.9,250.582l-3.174.283-.283-3.174Z",
    transform: "translate(-355.304 -228.92)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44239",
    "data-name": "Path 44239",
    d: "M247.284,351.823a.7.7,0,0,1-.755-.744,4.038,4.038,0,0,1,.168-.92,2.836,2.836,0,0,1,1.16-1.429q.275-.2.68-.46a5.842,5.842,0,0,0,.784-.606,3.06,3.06,0,0,0,.622-.787,1.68,1.68,0,0,0,.2-.983,1.587,1.587,0,0,0-.219-.7,1.647,1.647,0,0,0-.453-.486,1.694,1.694,0,0,0-.619-.267,2.3,2.3,0,0,0-.7-.045,2,2,0,0,0-.761.214,2.656,2.656,0,0,0-.6.424,3.106,3.106,0,0,0-.458.548.7.7,0,0,1-.931.225l-.652-.369a.693.693,0,0,1-.277-.92,3.666,3.666,0,0,1,.317-.505,4.1,4.1,0,0,1,.878-.868,4.457,4.457,0,0,1,1.108-.586,4.981,4.981,0,0,1,1.262-.278,5.1,5.1,0,0,1,1.47.083,3.7,3.7,0,0,1,1.347.563,3.525,3.525,0,0,1,1.035,1.107,3.894,3.894,0,0,1,.512,1.7,3.754,3.754,0,0,1-.048,1.106,3.052,3.052,0,0,1-.339.9,3.642,3.642,0,0,1-.576.753,7.318,7.318,0,0,1-.778.674q-.366.267-.734.514a4.672,4.672,0,0,0-.664.537,2.315,2.315,0,0,0-.469.646,1.339,1.339,0,0,0-.108.327.7.7,0,0,1-.621.567Zm-.365,3.879-.115-1.286a.694.694,0,0,1,.63-.753l.764-.068a.694.694,0,0,1,.753.63l.115,1.287a.694.694,0,0,1-.63.753l-.764.068a.694.694,0,0,1-.753-.63",
    transform: "translate(-225.879 -316.321)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44240",
    "data-name": "Path 44240",
    d: "M1098.873,452.656l-17.685,21.884,17.825,14.405,17.685-21.884Zm14.9,16.813-.476-4.482,2.479,2Z",
    transform: "translate(-999.252 -418.352)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44241",
    "data-name": "Path 44241",
    d: "M1309.158,693.987l-.593-.479,15.352-19-.006,1.22Z",
    transform: "translate(-1209.397 -623.394)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44242",
    "data-name": "Path 44242",
    d: "M1507.345,617.375l-2,2.479-.476-4.482Z",
    transform: "translate(-1390.822 -568.737)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44243",
    "data-name": "Path 44243",
    d: "M1106.537,468.606l-15.352,19L1073.361,473.2l17.355-21.475,15.346,12.4Z",
    transform: "translate(-992.017 -417.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44244",
    "data-name": "Path 44244",
    d: "M1480.912,619.853l-2.479-2,2-2.479Z",
    transform: "translate(-1366.393 -568.736)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44245",
    "data-name": "Path 44245",
    d: "M1240.112,612.936a.7.7,0,0,1-.025-1.059,4.042,4.042,0,0,1,.761-.544,2.835,2.835,0,0,1,1.827-.221q.336.047.809.142a5.835,5.835,0,0,0,.985.11,3.063,3.063,0,0,0,.994-.133,1.68,1.68,0,0,0,.823-.571,1.588,1.588,0,0,0,.331-.657,1.646,1.646,0,0,0,.012-.664,1.694,1.694,0,0,0-.259-.622,2.288,2.288,0,0,0-.469-.516,2,2,0,0,0-.7-.375,2.653,2.653,0,0,0-.723-.11,3.107,3.107,0,0,0-.71.075.7.7,0,0,1-.826-.485l-.212-.719a.693.693,0,0,1,.44-.854,3.666,3.666,0,0,1,.579-.143,4.1,4.1,0,0,1,1.235-.013,4.451,4.451,0,0,1,1.2.349,4.976,4.976,0,0,1,1.1.677,5.09,5.09,0,0,1,1,1.082,3.7,3.7,0,0,1,.577,1.341,3.524,3.524,0,0,1-.026,1.515,3.894,3.894,0,0,1-.813,1.578,3.759,3.759,0,0,1-.8.762,3.057,3.057,0,0,1-.868.41,3.646,3.646,0,0,1-.938.141,7.3,7.3,0,0,1-1.028-.057q-.449-.063-.885-.141a4.676,4.676,0,0,0-.851-.076,2.316,2.316,0,0,0-.786.139,1.335,1.335,0,0,0-.3.16.7.7,0,0,1-.84-.024Zm-2.959,2.535.812-1a.694.694,0,0,1,.976-.1l.6.482a.694.694,0,0,1,.1.976l-.812,1a.694.694,0,0,1-.977.1l-.6-.482a.694.694,0,0,1-.1-.977",
    transform: "translate(-1143.255 -559.646)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44246",
    "data-name": "Path 44246",
    d: "M329.507,536.164v32.047l-7.409,5.074-7.022,4.809-5,3.422H260.12a4.465,4.465,0,0,1-4.465-4.465V524.3a4.465,4.465,0,0,1,4.472-4.464l4.48.007,18.4.025a3.085,3.085,0,0,1,2.336,1.073l8.338,9.686a3.086,3.086,0,0,0,2.34,1.074h29.016a4.452,4.452,0,0,1,3.3,1.457l.078.086a4.451,4.451,0,0,1,1.089,2.923",
    transform: "translate(-236.281 -480.44)",
    fill: "#ffc192"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44247",
    "data-name": "Path 44247",
    d: "M333.993,1177.322H260.12a4.465,4.465,0,0,1-4.465-4.466v-5.838a4.465,4.465,0,0,0,4.465,4.465h43.9a19.561,19.561,0,0,0,11.056-3.422l7.022-4.809,7.409-5.074v13.305h.021v1.372a4.465,4.465,0,0,0,4.465,4.466",
    transform: "translate(-236.281 -1070.408)",
    fill: "#f2a66e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44248",
    "data-name": "Path 44248",
    d: "M3.562,943.587a1.781,1.781,0,1,1-1.781-1.781,1.781,1.781,0,0,1,1.781,1.781",
    transform: "translate(0 -870.433)",
    fill: "#00b4cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44249",
    "data-name": "Path 44249",
    d: "M1484.925,943.587a1.781,1.781,0,1,1-1.781-1.781,1.781,1.781,0,0,1,1.781,1.781",
    transform: "translate(-1369.099 -870.433)",
    fill: "#00b4cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44250",
    "data-name": "Path 44250",
    d: "M316.164,3.052A3.049,3.049,0,1,1,313.116,0a3.049,3.049,0,0,1,3.049,3.049",
    transform: "translate(-286.569 -0.003)",
    fill: "#00b4cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44251",
    "data-name": "Path 44251",
    d: "M163.1,965.31a17.285,17.285,0,1,0,17.275,17.274A17.274,17.274,0,0,0,163.1,965.31",
    transform: "translate(-134.772 -892.155)",
    fill: "#00b4cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44252",
    "data-name": "Path 44252",
    d: "M276.444,1084.6a17.311,17.311,0,0,1-11.324,11.325l-.084-.086c-.072-.071-.143-.142-.213-.214s-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.214-.213-.143-.142-.213-.214-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.144-.141-.214-.213-.143-.142-.213-.214-.144-.141-.214-.214-.144-.141-.214-.213-.143-.142-.213-.214-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.214-.213-.143-.142-.213-.214-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.214-.213-.143-.142-.213-.214-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.214-.213-.143-.142-.213-.214-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.214-.213-.143-.142-.213-.214-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.213-.213-.144-.141-.214-.214-.144-.141-.214-.214-.143-.141-.214-.213a8.008,8.008,0,1,1,11.323-11.323q.109.1.214.213c.072.071.143.141.213.214s.144.141.214.214.144.141.214.214.143.141.214.213.143.141.213.214.144.141.214.214.144.141.214.213.143.141.213.214.144.141.214.214.144.141.214.214.144.141.214.213.143.141.213.214.144.141.214.214.144.141.214.213.143.141.213.214.144.141.214.214.144.141.214.214.143.141.214.213.143.141.213.214.144.141.214.214.144.141.214.213.143.141.213.214.144.141.214.214.144.141.214.214.143.141.214.213.143.141.213.214.144.141.214.214.144.141.214.213.143.141.213.214.144.141.214.214.144.141.214.214.143.141.214.213.143.141.213.214.144.141.214.214.144.141.214.213.143.141.213.214.144.141.214.214.144.141.214.213.143.142.214.214.143.141.213.214.144.141.214.214.144.141.214.214.143.14.213.213.144.141.214.214.144.141.214.214.143.141.214.213.143.141.213.214.144.141.214.214.144.141.214.213.143.141.213.214.144.141.214.214.144.141.214.214.143.14.214.213.143.141.213.214.144.141.214.214l.086.083",
    transform: "translate(-231.63 -989.004)",
    fill: "#006494",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44253",
    "data-name": "Path 44253",
    d: "M258.635,1070.1a8.008,8.008,0,1,0,8.012,8.012,8.021,8.021,0,0,0-8.012-8.012m3.175,12.971a5.9,5.9,0,1,1,1.784-1.784,5.931,5.931,0,0,1-1.784,1.784",
    transform: "translate(-231.63 -989.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44254",
    "data-name": "Path 44254",
    d: "M405.8,1225.289a1.628,1.628,0,0,1-2.3,0l-4.048-4.047-.749-.749a1.621,1.621,0,0,1-.469-.989,5.937,5.937,0,0,0,1.784-1.784,1.621,1.621,0,0,1,.99.469l.749.749,4.047,4.047a1.629,1.629,0,0,1,0,2.3",
    transform: "translate(-368.053 -1125.437)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPage);
export default __webpack_public_path__ + "static/media/empty-page.0f620d222be81d7c1994f6043f1c5388.svg";
export { ForwardRef as ReactComponent };